import React from "react";
import { Box, Typography, Container } from "@mui/material";
import VendorUnansweredQuestions from "./VendorUnansweredQuestions";

const UnansweredQuestionsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Unanswered Questions
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Questions from your products that need your response. You can answer them directly from this page.
        </Typography>
      </Box>

      <VendorUnansweredQuestions />
    </Container>
  );
};

export default UnansweredQuestionsPage;